export const LogoFull = ({ light = false }) => (
    <img
        src="/brands/ftm-logo.png"
        alt="FTM Group S.r.l."
        data-testid="ftm-logo"
        className={`h-14 w-auto ${light ? "rounded-lg bg-white p-1.5 shadow-sm" : ""}`}
    />
);
